// extracted by mini-css-extract-plugin
export const follow = "Follow-module--follow--1CyM1";
export const follow_social = "Follow-module--follow_social--1zbST";